import { Component } from '@angular/core';

@Component({
    selector: 'nio-large-texas-city',
    templateUrl: './large-texas-city.component.html',
    styleUrls: ['./large-texas-city.component.scss'],
    standalone: false
})
export class LargeTexasCityComponent {}
